import { isAxiosError } from "axios";
import i18next from "i18next";

const BRANCH_VEHICLE_REFERENCE_CONFLICT_ERROR_CODE = "BRANCH_VEHICLE_REFERENCE_CONFLICT";

type BranchVehicleReferenceType = "currentLocation" | "ownership";

interface BranchVehicleReferenceConflictResponse {
  errorCode: typeof BRANCH_VEHICLE_REFERENCE_CONFLICT_ERROR_CODE;
  message: string;
  statusCode: number;
  details: {
    referenceType: BranchVehicleReferenceType;
    vehicleCount: number;
  };
}

export const BRANCH_DELETE_CUSTOM_ERRORS = { 409: null } as const satisfies Record<number, string | null>;

function isBranchVehicleReferenceConflictResponse(value: unknown): value is BranchVehicleReferenceConflictResponse {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<BranchVehicleReferenceConflictResponse>;
  const details = candidate.details;

  return (
    candidate.errorCode === BRANCH_VEHICLE_REFERENCE_CONFLICT_ERROR_CODE &&
    candidate.statusCode === 409 &&
    typeof candidate.message === "string" &&
    !!details &&
    (details.referenceType === "currentLocation" || details.referenceType === "ownership") &&
    Number.isInteger(details.vehicleCount) &&
    details.vehicleCount > 0
  );
}

export function resolveBranchDeleteErrorMessage(error: unknown, fallbackMessage: string): string {
  if (!isAxiosError(error) || error.response?.status !== 409) {
    return fallbackMessage;
  }

  const response = error.response.data;
  if (!isBranchVehicleReferenceConflictResponse(response)) {
    return i18next.t("common:DeleteBranchPermanentlyVehicleConflict");
  }

  const translationKey =
    response.details.referenceType === "currentLocation"
      ? "common:DeleteBranchPermanentlyCurrentLocationConflict"
      : "common:DeleteBranchPermanentlyOwnershipConflict";

  return i18next.t(translationKey, { count: response.details.vehicleCount });
}
